import { render, staticRenderFns } from "./withhold.vue?vue&type=template&id=64960b92&"
import script from "./withhold.vue?vue&type=script&lang=js&"
export * from "./withhold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64960b92')) {
      api.createRecord('64960b92', component.options)
    } else {
      api.reload('64960b92', component.options)
    }
    module.hot.accept("./withhold.vue?vue&type=template&id=64960b92&", function () {
      api.rerender('64960b92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auditOrder/withhold.vue"
export default component.exports